import SplitPageHero from '../common/SplitPageHero'
import { servicesHero } from '../../data/servicesPageData'

const servicesHeroImage = '/assets/services-hero-containers.png'

function ServicesPageHero() {
  const { eyebrow, titleLine1, titleAccent, titleLine2, description, primaryCta, secondaryCta } =
    servicesHero

  return (
    <SplitPageHero
      id="services-page-heading"
      eyebrow={eyebrow}
      title={
        <>
          {titleLine1}{' '}
          <span className="split-page-hero__title-accent">{titleAccent}</span>
          <br />
          {titleLine2}
        </>
      }
      description={description}
      image={servicesHeroImage}
      imageAlt="Shipping containers and logistics terminal at sunset"
      primaryCta={primaryCta}
      secondaryCta={secondaryCta}
    />
  )
}

export default ServicesPageHero
